import type { ApprovalDecision } from "~/components/tool-ui/approval-card";
import type { HitlToolProps } from "./hitlTools";
import type { ToolCallEntry } from "./useTurns";

// Derives the ApprovalCard interaction props shared by every approval-style HITL
// card (`ask_for_approval`, `public_dataset_trigger_run`): the
// prior decision as `choice`, plus approve/deny handlers that resume the paused
// run via `onAnswer`. The handlers are undefined in read-only views (no
// `onAnswer`), which disables the buttons; a rejected `onAnswer` re-enables them
// so retry just works.
//
// A denial is either the literal "denied" an external tool returns as its
// answer, or the denied outcome pydantic-ai marks on a `requires_approval` tool
// it refused to run. Any other result means the tool ran, i.e. was approved.
export function approvalWiring(entry: ToolCallEntry, onAnswer: HitlToolProps["onAnswer"]) {
  const choice: ApprovalDecision | undefined =
    entry.result === undefined
      ? undefined
      : entry.denied || entry.result === "denied"
        ? "denied"
        : "approved";
  return {
    choice,
    onConfirm: onAnswer ? () => onAnswer(entry.id, "approved") : undefined,
    onCancel: onAnswer ? () => onAnswer(entry.id, "denied") : undefined,
  };
}
